"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreePlanAnnouncementKey = exports.AutoLayoutAnnouncementKey = exports.PolygonAnnouncementKey = void 0;
const zod_1 = require("zod");
exports.PolygonAnnouncementKey = "polygon";
exports.AutoLayoutAnnouncementKey = "autoLayout";
/**
 * Don't get these directly, use getFreePlanAnnouncementKey()
 */
exports.FreePlanAnnouncementKey = zod_1.z.enum(["freePlan", "freePlanAfterDisabled"]);
//# sourceMappingURL=announcement.js.map